import { WorkPolicyFormValue } from "./hooks/use-work-policy-form";

export const policyKindCopy = {
  APPROVAL: {
    title: "결재 신청용 근무정책",
    short: "결재 신청용",
    helper: "실제 적용기간은 직원의 결재 신청 From~To에서 정합니다."
  },
  BASE: {
    title: "기본 근무정책",
    short: "기본 정책",
    helper: "환경설정의 적용 시작일과 종료일을 기준으로 미래 예정 데이터를 관리합니다."
  }
} as const;

export const workTypeCopy: Record<WorkPolicyFormValue["workType"], string> = {
  staggered: "시차출퇴근제",
  flexible: "탄력적 근로시간제",
  selective: "선택적 근로시간제"
};
